import Veiculo from "./Veiculo";

export default class Abastecimento {
  constructor(id, data, km, tipo, quantidade, valor, responsavel) {
    this.id = id;
    this.data = data;
    this.km = km;
    this.tipo = tipo;
    this.quantidade = quantidade;
    this.valor = valor;
    this.responsavel = responsavel;
    this.veiculo = new Veiculo(0, "", "", "", "", "", "");
  }

  update(abastecimento) {
    this.id = abastecimento.id;
    this.data = abastecimento.data;
    this.km = abastecimento.km;
    this.tipo = abastecimento.tipo;
    this.quantidade = abastecimento.quantidade;
    this.valor = this.getCurrency(abastecimento.valor);
    this.responsavel = abastecimento.responsavel;
    this.veiculo = abastecimento.veiculo;
  }

  getCurrency(valor) {
    valor = parseFloat(valor).toFixed(2);
    var inteira = valor.substr(0, valor.length - 3);
    var ajuste = inteira.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var decimal = valor.substr(valor.length - 3, valor.length);
    decimal = decimal.replace(".", ",");
    return "R$ " + ajuste + decimal;
  }

  setNumber() {
    this.valor = Number(this.valor.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
  }
}
